import React, { useState, useEffect } from 'react';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Chip,
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Alert,
  Snackbar,
  Divider,
  Grid, Switch, FormControlLabel
} from '@mui/material';
import {
  Edit,
  Delete,
  Add,
  AdminPanelSettings,
} from '@mui/icons-material';
import { getAdminUsers, getAdminRoles, createRole, editRole, deactivateRole } from '../services/adminUserService';
import CommonModal from '../components/common/CommonModal';
import { useNotification } from '../contexts/NotificationContext'



function AdminRoles({ refresh }) {
  const [roles, setRoles] = useState([]);
  const [editRole, setEditRole] = useState({})
  const [toggler,setToggler] = useState(true)
  const [roleModal, setRoleModal] = useState(false)
  const {showSuccess,showError} = useNotification()

  const fetchAdminUsers = async () => {
    try {
      const response = await getAdminRoles()
      // console.log("Admin Response => ", response)
      setRoles(response.data)
    }
    catch (error) {
      // console.error(error)
    }
  }

  useEffect(() => {
    fetchAdminUsers()
  }, [roleModal, refresh,toggler])



  const handleToggleRole = async (id) => {
    try{
      const response = await deactivateRole(id)
      showSuccess(response.message)
      let updatedToggler = !toggler
      setToggler(updatedToggler)
      
    }
    catch(error){
      showError(error?.message)
      let updatedToggler = !toggler
      setToggler(updatedToggler)
    }
  }


  return (
    <Box>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
              <TableCell sx={{ fontWeight: 'bold' }}>S.No</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Role Name</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Status</TableCell>
              {!JSON.parse(localStorage.getItem('admin_outlet_id')) && 
              <TableCell sx={{ fontWeight: 'bold' }}>Actions</TableCell> }
            </TableRow>
          </TableHead>
          <TableBody>
            {roles.map((role, index) => (
              <TableRow key={role.id} hover>
                <TableCell>{index + 1}</TableCell>
                <TableCell>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <AdminPanelSettings color="primary" fontSize="small" />
                    <Typography variant="body2">{role.role}</Typography>
                  </Box>
                </TableCell>
                <TableCell>
                  <Chip
                    label={role.active ? "Active" : "Inactive"}
                    size="small"
                    color={role.active ? 'success' : 'default'}
                    variant="outlined"
                  />
                </TableCell>
                {!JSON.parse(localStorage.getItem('admin_outlet_id')) && 
                <TableCell>
                  <IconButton
                    size="small"
                    color="primary"
                    onClick={() => {
                      setRoleModal(true)
                      setEditRole({
                        "id": role.id,
                        "role": role.role,
                        "tabs_permitted": role.tabs_permitted
                      })
                    }}
                    sx={{ mr: 1 }}
                  >
                    <Edit fontSize="small" />
                  </IconButton>

                  <Switch
                    size="small"
                    color="success"
                    checked={role.active}   // or role.status === "active"
                    onChange={(e) => handleToggleRole(role.id)}
                  />
                </TableCell> 
                }
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <CommonModal modalOpen={roleModal} setModalOpen={setRoleModal} children={<RoleModal setModalOpen={setRoleModal} editRoleState={editRole} />} modalWidth={600} />
    </Box>
  );
}


const RoleModal = ({ setModalOpen, editRoleState }) => {
  const [tabs, setTabs] = useState([
   
    { "name": "Delivery", "value": "delivery" },
    { "name": "Reservations", "value": "reservations" },
    { "name": "Table Orders", "value": "table_orders" },
    { "name": "Catering Info", "value": "catering_info" },
    { "name": "Catering Config", "value": "catering_config" },
    { "name": "Notification", "value": "notifications" },
    { "name": "Reports", "value": "reports" },
    { "name": "Outlets", "value": "outlets" },
    { "name": "Configuration", "value": "configuration" },
    { "name": "Social Links", "value": "social_links" },
    { "name": "User Settings", "value": "user_settings" },
    { "name": "Users", "value": "users" },
    { "name": "Token Management", "value": "token_management" },
    { "name": "Printers", "value": "printers" },
    { "name": "Testimonials", "value": "testimonials" },
    { "name": "Feedback", "value": "feedback" },
    { "name": "Menu", "value": "menu" },
    // { "name": "Analytics", "value": "analytics" },


    // { "name": "Analytics", "value": "analytics" },
  ]);

  const [switchValues, setSwitchValues] = useState(
    {
      "configuration": false,
      "social_links": false,
      "outlets": false,
      "menu": false,
      "delivery": false,
      "catering_config": false,
      "catering_info": false,
      "reports": false,
      "notifications": false,
      "reservations": false,
      "table_orders": false,
      "token_management": false,
      "testimonials": false,
      "users": false,
      "user_settings": false,
      "analytics": false
    }
  );
  const [roleName, setRoleName] = useState('');
  const { showSuccess, showError } = useNotification()

  const getRoleDataForEdit = async () => {
    try {
      const response = await editRole()
      setRoleName(response.role)
    }
    catch (Error) {
      // console.error(Error)
    }
  }

  // console.log("Edit Role State => ", editRoleState)

  useEffect(() => {
    setRoleName(editRoleState.role)
    setSwitchValues(editRoleState.tabs_permitted)
  }, [])



  const handleChange = (value, checked) => {
    setSwitchValues(prev => ({
      ...prev,
      [value]: checked
    }));
  };

  const handleRoleNameChange = (e) => {
    setRoleName(e.target.value);
  };

  const handleSelectAll = () => {
    const allSelected = {};
    tabs.forEach(tab => {
      allSelected[tab.value] = true;
    });
    setSwitchValues(allSelected);
  };

  const handleClearAll = () => {
    setSwitchValues({
      "configuration": false,
      "social_links": false,
      "outlets": false,
      "menu": false,
      "delivery": false,
      "catering_config": false,
      "catering_info": false,
      "reports": false,
      "notifications": false,
      "reservations": false,
      "table_orders": false,
      "token_management": false,
      "testimonials": false,
      "users": false,
      "user_settings": false,
      "analytics": false
    });
  };

  const handleUpdateRole = async () => {

    // console.log("Switch Values => ", switchValues)
    let payload = {

      "role": roleName,
      "tabs_permitted": switchValues
    }

    try {
      const response = await editRole(editRoleState.id, payload)
      showSuccess(response?.data?.message)
      setModalOpen(false)
    }
    catch (error) {
      // console.error(error)
    }

  }

  return (
    <>
      <Typography variant='h5' sx={{ textAlign: 'center', mb: 3, fontWeight: 'bold' }}>
        Create Role
      </Typography>

      <TextField
        fullWidth
        label="Role Name"
        value={roleName}
        onChange={handleRoleNameChange}
        sx={{ mb: 3 }}
        variant="outlined"
        placeholder="Enter role name"
      />

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mb: 2 }}>
        <Button
          variant="outlined"
          size="small"
          onClick={handleSelectAll}
        >
          Select All
        </Button>
        <Button
          variant="outlined"
          size="small"
          color="error"
          onClick={handleClearAll}
        >
          Clear All
        </Button>
      </Box>

      <Divider sx={{ mb: 2 }} />

      <Grid container spacing={2}>
        {tabs.map((tab, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <FormControlLabel
              control={
                <Switch
                  checked={switchValues[tab.value] || false}
                  onChange={(e) => handleChange(tab.value, e.target.checked)}
                  color="primary"
                  size="medium"
                />
              }
              label={tab.name}
              sx={{
                width: '100%',
                m: 0,
                p: 1,
                borderRadius: 1,
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                },
              }}
            />
          </Grid>
        ))}
      </Grid>

      <Divider sx={{ my: 3 }} />

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
        <Button variant="outlined" color="inherit" onClick={()=>setModalOpen(false)}>
          Cancel
        </Button>
        <Button variant="contained" color="primary"
          onClick={handleUpdateRole}
        >
          Update Role
        </Button>
      </Box>
    </>
  );
};



export default AdminRoles;